<template>
  <div class="main_area" style="height: 689px">
    <div class="type_menu_area">
      <div class="type_menu wallet_menu menu_area_bg">
        <div class="type_menu_item">
          <a @click="$parent.goNav('/wallet')"><span>存款</span></a>
        </div>
        <div class="type_menu_item">
          <a @click="$parent.goNav('/withdraw')"><span>取款</span></a>
        </div>
        <div class="type_menu_item active">
          <a><span>转账</span></a>
        </div>
      </div>
    </div>

    <div class="detail_area">
      <div class="deposit-container wallet-container layout seamless">
        <!-- <div class="wallet_amount ">
				<div class="wallet_amount_item">
					<div>主钱包余额</div>
					<div><span id="all_wallet_balance">{{ $store.state.userInfo.balance }}</span></div>
				</div>
			</div> -->
        <div class="deposit_container transfer_container layout">
          <div class="deposit_header tableheader_bg">
            <div>游戏余额</div>
            <div class="d-flex align-items-center">
              <span class="wallet_balance mr-2 main_wallet_bal" id="wallet_bal">{{ $store.state.userInfo.gameblance }}</span> <img alt="" @click="$parent.getUserInfos" src="/static/image/refresh_reverse.png" id="reload_wallet" />
            </div>
            <input id="main_wallet_amount" type="hidden" :value="$store.state.userInfo.gameblance" />
          </div>
          <!-- 免转开启 -->
          <div class="deposit_body wallet_deposit_body default">
            <div class="turnover_transfer_part mb-2" v-if="$store.state.userInfo.transferstatus == 1">
              <button class="btn btn_trans_red turnover_detail_btn w-50 mr-2" toggle-modal="bottommodal" data-target="current_turnover" @click="$parent.goNav('/meyList')">交易记录</button>
              <div class="transfer_seamless_type w-40 seamless_fixed_position">
                <div>免转</div>
                <div class="type_menu_area2 slide_btn" @click="changeTasfer">
                  <div class="type_menu on">
                    <div class="type_menu_item2" data-seamless="0">
                      <span></span>
                      <div class="type_menu_bg2" style="left: 103%"></div>
                    </div>
                    <div class="type_menu_item2 active" data-seamless="1"><span></span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="turnover_transfer_part mb-2" v-if="$store.state.userInfo.transferstatus == 0">
              <button class="btn btn_trans_red turnover_detail_btn w-50 mr-2" toggle-modal="bottommodal" data-target="current_turnover" @click="$parent.goNav('/meyList')">交易记录</button>
              <div class="transfer_seamless_type w-40">
                <div>免转</div>
                <div class="type_menu_area2 slide_btn" @click="changeTasfer">
                  <div class="type_menu">
                    <div class="type_menu_item2 active" data-seamless="0">
                      <span></span>
                      <div class="type_menu_bg2" style="left: 3%"></div>
                    </div>
                    <div class="type_menu_item2" data-seamless="1"><span></span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="transfer_btn_section">
              <div class="mr-2 shortcut_key_explaination" style="">
                <div>快捷键</div>
                <div class="onekey_description">
                  <div id="onekey_trans_in"><img alt="" src="/static/image/allin_remark.png" />一键转入指定游戏钱包</div>
                  <div id="onekey_trans_out"><img alt="" src="/static/image/allout_remark.png" />一键转入主钱包</div>
                </div>
              </div>
              <button @click="transall" class="btn btn_trans_red w-100 btn_retrieve active" type="button" id="oneKeyRecovery_btn" style="">一键领取</button>
            </div>
            <div id="transfer_wallet" v-if="$store.state.userInfo.transferstatus == 1">
              <div class="transfer_item_area wallet_tranfer none">
                <div class="transfer_item" data-maintenance="" data-wid="2" v-for="(item, index) in balancelist" :key="index" v-if="item.platname != 'userbalance'">
                  <div style="display: none"><img alt="" src="/static/image/gameCategoryImage1634600026.png" /></div>
                  <div class="vendor_title">{{ item.name }}</div>
                  <div class="vendor_amount seamless">
                    <div class="amount_linked">
                      <div id="t_gw_2">{{ item.balance }}</div>
                    </div>

                    <div class="oneKey_in" data-from="0" data-to="2">
                      <span><img alt="" src="/static/image/allin.png" width="18" /></span>
                    </div>
                    <div class="oneKey_out" data-from="2" data-to="0">
                      <span><img alt="" src="/static/image/allout.png" width="18" /></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="show_more show_more_option">更多</div>
            </div>
            <div id="transfer_wallet" v-if="$store.state.userInfo.transferstatus == 0">
              <div class="transfer_item_area wallet_tranfer wallet_tranfers show_more_height">
                <div class="transfer_item" data-maintenance="" data-wid="2" v-for="(item, index) in balancelist" :key="index" v-if="item.platname != 'userbalance'" @click="openTab(index - 1)">
                  <div style="display: none"><img alt="" src="/static/image/gameCategoryImage1634600026.png" /></div>
                  <div class="vendor_title">{{ item.name }}</div>
                  <div class="vendor_amount">
                    <div class="amount_linked">
                      <div id="t_gw_2">{{ item.balance }}</div>
                    </div>
                    <input id="t_gw_2_wallet_amount" type="hidden" value="0.00" />

                    <div class="oneKey_in" data-from="0" data-to="2" @click="changVal(0, item.platname, index - 1)">
                      <span><img alt="" src="/static/image/allin.png" width="18" /></span>
                    </div>
                    <div class="oneKey_out" data-from="2" data-to="0" @click="changVal(1, item.platname, index - 1)">
                      <span><img alt="" src="/static/image/allout.png" width="18" /></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="show_more active" @click="changText">更多</div>
            </div>
          </div>
        </div>
      </div>

      <div class="withdrawal_form_container transfer_bottom" v-if="$store.state.userInfo.transferstatus == 0">
        <div class="withdrawal_scrollable_form">
          <div>
            <div class="vendor_select">
              <div>
                <label>转出钱包</label>
                <div>
                  <select class="vendor_select_out_input" id="from_wallet" v-model="sourcetype">
                    <option :value="item.platname" v-for="(item, index) in balancelist" :key="index">{{ item.name }}</option>
                  </select>
                </div>
              </div>
              <div class="in_out_exchange_btn" @click="changTypes"><img alt="" src="/static/image/exchange.png" /></div>
              <div>
                <label>转入钱包</label>
                <div>
                  <select class="vendor_select_in_input" v-model="targettype">
                    <option :value="item.platname" v-for="(item, index) in balancelist" :key="index">{{ item.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div>
              <label class="textbox_content">
                <input class="transfer_amount finance_amount" type="text" placeholder="转账金额" v-model="amount" />
                <div class="error_msg"></div>
              </label>
              <div class="deposit_hints transfer_hints_txt">温馨提示：转账可能因平台政策，出现无法转入或转出之情形。如有疑问，敬请联系客服为您服务。</div>
              <div class="textbox_content">
                <button class="btn transfer_btn" type="button" @click="isOk">确定</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_bottom no_ribbon" id="current_turnover">
      <div class="modal_dialog" role="document">
        <div class="modal_content">
          <div class="modal_header">
            <!--div class="modal_dismiss" data-dismiss='bottommodal'></div-->
            <div class="text-center w-100">流水详情</div>
          </div>
          <div class="modal_body">
            <div class="turnover_body">
              <div class="layout turnover_layout">
                <div class="deposit_container layout">
                  <div class="deposit_header">
                    <div>需达流水</div>
                    <div class="d-flex align-items-center"><span class="turnover_remaining mr-2">0.00</span> <img alt="" src="/static/image/refresh_reverse.png" id="reload_turnover" /></div>
                  </div>
                </div>
                <div class="progress_details">
                  <div class="turnover_progress_bg progress_text_inside progress_with_text w-100">
                    <div class="masking">
                      <div class="progress-bar" role="progressbar" id="turnover_progress" style="width: 0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <div class="start">
                      已达流水
                      <div class="breaknum">0</div>
                    </div>
                    <div class="end">
                      流水需求
                      <div class="breaknum">0.00</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-container" id="current_turnover_details">
                <div class="swiper-wrapper"></div>
                <div class="swiper-pagination" style="position: unset"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'transfer',
  data() {
    return {
      balancelist: [],
      amount: null,
      targettype: null,
      sourcetype: null,
      daoTime: null,
    };
  },
  created() {
    let that = this;
    that.getbalancelist();
    that.daoTime = setInterval(() => {
      that.getbalancelistNoLoding();
    }, 1500);
  },
  methods: {
    changTypes() {
      let that = this;
      let [left, right] = [that.sourcetype, that.targettype];
      that.sourcetype = right;
      that.targettype = left;
    },
    isOk() {
      let that = this;
      let info = { amount: that.amount, sourcetype: that.sourcetype, targettype: that.targettype };
      if (that.amount == null) {
        that.showTost(0, '请输入操作金额！');
        return;
      }
      if (that.sourcetype == null) {
        that.showTost(0, '请选择转出平台');
        return;
      }
      if (that.targettype == null) {
        that.showTost(0, '请选择转入平台');
        return;
      }
      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelist();
          that.amount = null;
          that.sourcetype = null;
          that.targettype = null;
        } else {
          that.hideLoading();
        }
      });
    },

    getbalancelist() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            let balancelist = res.data;
            balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
            balancelist.forEach(element => {
              element.balance = '读取中..';
            });
            that.balancelist = balancelist;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
        .post('/api/balancelist2', {})
        .then(res => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            let balancelist = res.data;
            balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
            that.balancelist = balancelist;
          }
        })
        .catch(res => {});
    },
    changeTasfer() {
      let that = this;
      that.showLoading();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let mianzhuan = userInfo.transferstatus ? 0 : 1;

      that.$apiFun
        .post('/api/uptransferstatus', { transferstatus: mianzhuan })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            userInfo.transferstatus = mianzhuan;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
            that.showTost(1, '操作成功！');
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    transall() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.refreshusermoney();
          that.$parent.getUserInfos();
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    openTab(e) {
      let that = this;
      let _this = $('.wallet_tranfers').children().eq(e); //当前点击元素
      _this.toggleClass('active');
      _this.siblings().removeClass('active');
    },
    changVal(type, platname, e) {
      let that = this;
      if (type == 0) {
        //转入游戏
        that.sourcetype = 'userbalance';
        that.targettype = platname;
      } else {
        //转入平台
        that.sourcetype = platname;
        that.targettype = 'userbalance';
      }
      let _this = $('.wallet_tranfers').children().eq(e); //当前点击元素
      _this.siblings().removeClass('active');
      $('.show_more').text('更多');
      $('.wallet_tranfer').toggleClass('show_more_height');
      $('.show_more').toggleClass('active');
    },
    changText() {
      let text = $('.show_more').text();
      let newText = text == '更多' ? '收起' : '更多';
      $('.show_more').text(newText);
      $('.wallet_tranfer').toggleClass('show_more_height');
      $('.show_more').toggleClass('active');
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    showTost(n, s) {
      this.$parent.showTost(n, s);
    },
  },
  mounted() {
    let that = this;
    // 初始是收起展示
    // $('.show_more').text('更多');
    // $('.wallet_tranfer').toggleClass('show_more_height');
    // $('.show_more').toggleClass('active');
    // // 更多 更少的控制
    // $('.show_more').click(function () {
    //   if ($('.wallet_tranfer').hasClass('show_more_height')) {
    //     $(this).text('收起');
    //   } else {
    //     $(this).text('更多');
    //   }
    //   $('.wallet_tranfer').toggleClass('show_more_height');
    // });
    // $('.show_more').click(function () {
    //   $(this).toggleClass('active');
    // });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>
<style lang="scss" scoped>
.seamless .transfer_item.active .oneKey_in,
.seamless .transfer_item.active .oneKey_out {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/transfer.vue